import type { ArtifactResult } from "~/services/aiOrchestrator";

import base64ToBlob from "~/helpers/base64ToBlob";
import logger from "~/helpers/logger";

const HTML_MIME_TYPES = new Set(["text/html", "application/xhtml+xml"]);

export const isHtmlArtifact = (artifact: Pick<ArtifactResult, "mimeType">): boolean =>
	HTML_MIME_TYPES.has(artifact.mimeType.split(";")[0].trim().toLowerCase());

const decodeArtifactBlob = (contentBase64: string, mimeType: string): Blob => {
	try {
		return base64ToBlob(contentBase64, mimeType);
	} catch (error) {
		logger.error("Failed to decode report artifact", error);
		return new Blob([], { type: mimeType });
	}
};

export const createArtifactObjectUrl = (artifact: ArtifactResult): string | null => {
	try {
		return URL.createObjectURL(decodeArtifactBlob(artifact.contentBase64, artifact.mimeType));
	} catch (error) {
		logger.error("Failed to create report artifact object URL", error);
		return null;
	}
};

export const revokeArtifactObjectUrl = (url: string | null): void => {
	if (!url) return;
	try {
		URL.revokeObjectURL(url);
	} catch (error) {
		logger.error("Failed to revoke report artifact object URL", error);
	}
};

const downloadArtifact = (artifact: ArtifactResult): void => {
	const url = createArtifactObjectUrl(artifact);
	if (!url) return;
	try {
		const anchor = document.createElement("a");
		anchor.href = url;
		anchor.download = artifact.filename;
		document.body.appendChild(anchor);
		anchor.click();
		document.body.removeChild(anchor);
	} catch (error) {
		logger.error("Failed to download report artifact", error);
	} finally {
		revokeArtifactObjectUrl(url);
	}
};

export default downloadArtifact;
